// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "loginRxVuejs.umd.min." + chunkId + ".js";
};